"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactResizeObserver = _interopRequireDefault(require("react-resize-observer"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Resizeable Cell component
 *
 * @param   {Object}  props  Props
 */
var ResizeCell = function ResizeCell(props) {
  var celleditor = props.celleditor,
    tableRef = props.tableRef,
    onUpdate = props.onUpdate,
    infos = props.infos;
  var cellref = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    rowHeight = _useState2[0],
    setRowHeight = _useState2[1];
  var getElementIndexByParent = function getElementIndexByParent(parent, child) {
    return Array.prototype.indexOf.call(parent.childNodes, child);
  };
  var onUpdateRowHeight = function onUpdateRowHeight(rect) {
    if (cellref.current && tableRef.current && tableRef.current.table) {
      var trElement = cellref.current.closest('tr');
      var bodyElemnt = trElement.closest('tbody');
      var trIndex = getElementIndexByParent(bodyElemnt, trElement);
      var tableTBody = tableRef.current.table.querySelector('div.react-bs-container-body > table > tbody');
      var trUpdate = tableTBody.childNodes[trIndex];
      if (trUpdate) {
        var diffOffset = trUpdate.offsetHeight - trUpdate.clientHeight;
        var newHeight = rect.height + diffOffset;
        trUpdate.style.height = "".concat(newHeight, "px");
      }
    }
  };

  /**
   * Add / remove event listener for outside wrapper
   */
  (0, _react.useEffect)(function () {
    // keep initital row height
    if (cellref.current) {
      var trElement = cellref.current.closest('tr');
      setRowHeight(trElement.clientHeight);
    }
    return function () {
      onUpdateRowHeight({
        height: rowHeight
      });
    };
  }, [cellref, tableRef]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "cell-resize",
    ref: cellref
  }, /*#__PURE__*/_react.default.createElement(_reactResizeObserver.default
  // hanlde update row header height of current row when current row resize
  , {
    onResize: function onResize(rect) {
      onUpdateRowHeight(rect);
    }
  }), celleditor.customEditor && celleditor.customEditor.getElement(onUpdate, infos));
};
ResizeCell.propTypes = {
  celleditor: _propTypes.default.shape({
    customEditor: _propTypes.default.shape({
      getElement: _propTypes.default.func.isRequired
    }).isRequired
  }).isRequired,
  tableRef: _propTypes.default.element.isRequired,
  onUpdate: _propTypes.default.func.isRequired,
  infos: _propTypes.default.shape({}).isRequired
};
ResizeCell.defaultProps = {};
var _default = ResizeCell;
exports.default = _default;